<!-- PC - Footer -->
<footer *ngIf="controllerService.userIsLogged">

    <div id="footer" class="footer-pc">

        <div class="footer-left-pc">           

            <button class="mat-button-custom custom-font-family"  
                (click)="button_logout()"
                >
                <mat-icon>person</mat-icon>
                {{languageService.Strings.buttons.button_logout}}
            </button>
            
        </div>
       
    </div>
    
</footer>
